<template>
  <div style="position: relative">
    <v-container fluid class="grey lighten-4" pa-0>
      <v-row no-gutters style="container-data-filter-buttons">
        <v-col class="align-self-center" md="auto" xs="auto" sm="auto">
          <!-- Back button -->
          <crud-button
            x-large
            color="blue-grey darken-1"
            @clicked="back()"
            icon="fa-chevron-left"
            :tooltip="$t('global.crud.buttons.return')"
          />
        </v-col>
        <v-col
          cols="1"
          class="flex-grow-1 flex-shrink-0 container-data-filter-info"
        >
          <v-container fluid pa-0>
            <v-row>
              <v-col sm="12" cols="12">
                <div class="form-field-name">
                  {{ $t("productsTypesRelations.productType") }}
                </div>
                <div class="form-field-value">
                  {{ productType }}
                </div>
              </v-col>
            </v-row>
          </v-container></v-col
        >
      </v-row>
    </v-container>
    <div id="dataContainer">
      <!-- Table -->
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :page.sync="pagination.page"
        :server-items-length="pagination.totalItems - 1"
        :no-results-text="$t('global.datatable.noMatchingResults')"
        :no-data-text="$t('global.datatable.noDataAvailable')"
        :footer-props="{
          'items-per-page-options': rowsPerPageItems,
          'show-first-last-page': true,
          'show-current-page': true
        }"
        :loading="loading"
        light
        multi-sort
        dense
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.code">
              <td>{{ item.code }} - {{ item.name }}</td>
              <td>
                <v-btn-toggle
                  v-model="item.relation"
                  @change="manageButtons(item)"
                  rounded
                >
                  <v-btn value="D">
                    {{ buttonD }}
                  </v-btn>
                  <v-btn value="I">
                    {{ buttonI }}
                  </v-btn>
                  <v-btn value="C">
                    {{ buttonC }}
                  </v-btn>
                </v-btn-toggle>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import CrudButton from "@/components/Button.vue";
import localhttp from "../js/https-commons";

const CONTEXT_PRODUCTS_TYPES = "/productsTypes";
const CONTEXT_PRODUCTS_TYPES_RELATIONS = "/productsTypesRelations";

export default {
  components: {
    CrudButton
  },
  name: "ProductsTypesRelations",
  props: {
    productType: {
      type: String,
      required: true
    }
  },
  data: () => ({
    productsTypes: {
      isLoading: false,
      entries: [],
      search: null,
      value: "",
      isEdit: false
    },
    relation: {
      productTypeCode: "",
      productTypeRelationCode: "",
      relation: ""
    },
    buttonText: "boton",
    item: {},
    items: [],
    relationItems: [],
    filter: {
      allFields: "",
      code: "",
      deletedItems: "ALL"
    },
    options: {},
    pagination: {
      totalItems: 0,
      page: 1
    },
    rowsPerPageItems: [10, 20, 30, 40]
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("productsTypesRelations.productType"),
          value: "productTypeCode",
          sortable: false
        },
        {
          text: this.$t("productsTypesRelations.relation"),
          sortable: false
        }
      ];
    },
    buttonD() {
      return this.$t("productsTypesRelations.dependent");
    },
    buttonI() {
      return this.$t("productsTypesRelations.incompatible");
    },
    buttonC() {
      return this.$t("productsTypesRelations.purchased");
    }
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true
    },
    items: function() {
      this.setRelations();
    },
    relationItems: function() {
      this.setRelations();
    }
  },
  methods: {
    setRelations() {
      if (this.relationItems != undefined) {
        this.relationItems.forEach(x => this.setRelation(x));
      }
    },
    setRelation(rel) {
      if (this.items != undefined) {
        let product = this.items.find(
          y => y.code == rel.productTypeRelationCode
        );
        if (product != undefined) {
          product.relation = rel.relation;
        }
      }
    },
    async loadData() {
      await this.loadProductsTypes();
      await this.loadProductsTypesRelations();
      this.setRelations();
      this.$forceUpdate();
    },
    async loadProductsTypes() {
      console.debug("Search elements");

      // Items have already been requested
      if (this.loading) return;

      this.loading = true;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.filter.sortBy = sortBy;
      this.filter.sortDesc = sortDesc;
      this.filter.page = page;
      this.filter.itemsPerPage = itemsPerPage;
      this.filter.deletedItems = "ACTIVE";

      await localhttp
        .post(CONTEXT_PRODUCTS_TYPES + "/allPagination", this.filter)
        .then(response => {
          this.pagination.totalItems = response.data.totalElements;
          this.items = response.data.content.filter(
            x => x.code != this.productType
          );
          this.items.forEach(x => (x.relation = ""));
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$showError();
        });
    },
    async loadProductsTypesRelations() {
      await localhttp
        .get(CONTEXT_PRODUCTS_TYPES_RELATIONS + "/all/" + this.productType)
        .then(response => {
          this.relationItems = response.data;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$showError();
        });
    },
    close() {
      this.dialog = false;
    },
    resetDialog() {
      this.item = {};
      requestAnimationFrame(() => {
        if (this.$refs.obs !== undefined) {
          this.$refs.obs.reset();
        }
      });
    },
    back() {
      this.$router.push({
        name: "productsTypes"
      });
    },
    beforeMount() {
      this.productType = this.$props.productType;
    },
    mounted() {
      this.loadData();
    },
    manageButtons(item) {
      if (item.relation == undefined) {
        this.removeRelation(this.productType, item.code);
      } else {
        if (
          this.relationItems.filter(x => x.productTypeRelationCode == item.code)
            .length > 0
        ) {
          this.relationItems.find(
            x => x.productTypeRelationCode == item.code
          ).relation = item.relation;
          this.updateRelation(this.productType, item);
        } else {
          this.addRelation(item.code, item.relation);
        }
      }
      this.items = null;
      this.relationItems = null;
      this.loadData();
    },
    async updateRelation(productType, productTypeRelation) {
      this.relation.productTypeCode = this.productType;
      this.relation.productTypeRelationCode = productTypeRelation.code;
      this.relation.relation = productTypeRelation.relation;
      await localhttp
        .put(
          CONTEXT_PRODUCTS_TYPES_RELATIONS +
            "/update/" +
            productType +
            "/" +
            productTypeRelation.code,
          this.relation
        )
        .then(response => {
          console.log(response + "Relation updated");
        })
        .catch(e => {
          console.log(e);
        });
    },
    async removeRelation(productType, productTypeRelation) {
      await localhttp
        .put(
          CONTEXT_PRODUCTS_TYPES_RELATIONS +
            "/delete/" +
            productType +
            "/" +
            productTypeRelation
        )
        .then(response => {
          console.log(response + "Relation removed");
        })
        .catch(e => {
          console.log(e);
        });
    },
    async addRelation(productTypeCode, relationType) {
      this.relation.productTypeCode = this.productType;
      this.relation.productTypeRelationCode = productTypeCode;
      this.relation.relation = relationType;
      await localhttp
        .post(CONTEXT_PRODUCTS_TYPES_RELATIONS + "/create", this.relation)
        .then(response => {
          console.log(response + "Relation added");
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
